import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.73656 1.37082C5.84902 1.1437 6.08054 1 6.33398 1H9.66732C9.92269 1 10.1556 1.14588 10.2671 1.37562L11.2171 3.33333H14.0007C14.3688 3.33333 14.6673 3.63181 14.6673 4C14.6673 4.36819 14.3688 4.66667 14.0007 4.66667H13.0007V14.3333C13.0007 14.7015 12.7022 15 12.334 15H3.66732C3.29913 15 3.00065 14.7015 3.00065 14.3333V4.66667H2.00065C1.63246 4.66667 1.33398 4.36819 1.33398 4C1.33398 3.63181 1.63246 3.33333 2.00065 3.33333H4.76473L5.73656 1.37082ZM6.25259 3.33333H9.73505L9.24981 2.33333H6.74778L6.25259 3.33333ZM7.33398 7C7.33398 6.63181 7.03551 6.33333 6.66732 6.33333C6.29913 6.33333 6.00065 6.63181 6.00065 7V11C6.00065 11.3682 6.29913 11.6667 6.66732 11.6667C7.03551 11.6667 7.33398 11.3682 7.33398 11V7ZM10.0007 7C10.0007 6.63181 9.70217 6.33333 9.33398 6.33333C8.96579 6.33333 8.66732 6.63181 8.66732 7V11C8.66732 11.3682 8.96579 11.6667 9.33398 11.6667C9.70217 11.6667 10.0007 11.3682 10.0007 11V7Z"
      fill="currentColor"
    />
  </svg>
);
